import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TIMELINE_SIMULATOR_FORM2_CONSTANTS } from '../models/timeline-criteria-form2-constants';
import { AuthService } from '../../../../shared/services/auth.service';
import { SimulatorCriteriaExtractor } from './simulator-criteria-extractor.interface';

@Injectable()
export class SimulatorCriteriaForm2ExtractorService implements SimulatorCriteriaExtractor {
  private readonly authService = inject(AuthService);

  getCriteria(form: FormGroup) {
    const authUser = this.authService.getAuthUser();
    const formValue = form.value;
    const value: Record<string, string | boolean | number> = {};
    const CONSTANTS = TIMELINE_SIMULATOR_FORM2_CONSTANTS;

    value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.PROJECT_TYPE] = formValue.projectType;

    if (formValue.projectType === CONSTANTS.TIMELINE_CAMPAIGN_TYPES.PRODUCT_CAMPAIGN) {
      value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.PRODUCT_LAUNCH_TYPE] = formValue.productLaunchType;

      if (formValue.complexity) {
        value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.COMPLEXITY] = formValue.complexity;
      }

      value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.CAMPAIGN_TYPE] = formValue.campaignType;

      if (formValue.posm) {
        switch (formValue.posm) {
          case CONSTANTS.POSM_VALUES.DMI_PRODUCED:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM] = 'Yes';
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.DMI_PRODUCED] = 'Yes';
            break;
          case CONSTANTS.POSM_VALUES.LOCALLY_PRODUCED:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM] = 'Yes';
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.LOCALLY_PRODUCED] = 'Yes';
            break;
          case CONSTANTS.POSM_VALUES.NO:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM] = 'No';
            break;
        }
      } else {
        value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM] = 'No';
      }
    } else if (formValue.projectType === CONSTANTS.TIMELINE_CAMPAIGN_TYPES.HALLMARKS) {
      value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.HALLMARKS_TYPE] = formValue.hallmarksType;

      switch (formValue.collectorType) {
        case CONSTANTS.COLLECTOR_TYPES.INCLUDE_FOR_CHINA:
          value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.COLLECTOR] = 'Yes';
          value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.INCLUDE_FOR_CHINA] = 'Yes';
          break;
        case CONSTANTS.COLLECTOR_TYPES.NOT_FOR_CHINA:
          value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.COLLECTOR] = 'Yes';
          value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.INCLUDE_FOR_CHINA] = 'No';
          break;
        case CONSTANTS.COLLECTOR_TYPES.NO:
          value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.COLLECTOR] = 'No';
          break;
        case CONSTANTS.COLLECTOR_TYPES.YES:
          value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.COLLECTOR] = 'Yes';
          break;
      }

      if (formValue.collectorComplexity) {
        value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.COMPLEXITY] = formValue.collectorComplexity;
      }

      if (formValue.set) {
        switch (formValue.set) {
          case CONSTANTS.POSM_VALUES.DMI_PRODUCED:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.SET] = 'Yes';
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.SET_DMI_PRODUCED] = 'Yes';
            break;
          case CONSTANTS.POSM_VALUES.LOCALLY_PRODUCED:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.SET] = 'Yes';
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.SET_LOCALLY_PRODUCED] = 'Yes';
            break;
          case CONSTANTS.POSM_VALUES.NO:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.SET] = 'No';
            break;
        }
      }

      if (formValue.posm) {
        switch (formValue.posm) {
          case CONSTANTS.POSM_VALUES.DMI_PRODUCED:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM] = 'Yes';
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM_DMI_PRODUCED] = 'Yes';
            break;
          case CONSTANTS.POSM_VALUES.LOCALLY_PRODUCED:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM] = 'Yes';
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM_LOCALLY_PRODUCED] = 'Yes';
            break;
          case CONSTANTS.POSM_VALUES.NO:
            value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.POSM] = 'No';
            break;
        }
      }
    }

    value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.COMPANY_ID] = authUser?.company?.id;
    value[CONSTANTS.SIMULATOR_CRITERIA_KEYS.LAUNCH_POTENTIAL] = 1;

    return value;
  }
}
